import { defineComponent as t, openBlock as a, createBlock as n, unref as l, mergeProps as m, withCtx as p, createElementVNode as i } from "vue";
import { RevIcon as u } from "@ds/components/Icon";
const f = /* @__PURE__ */ t({
  name: "IconEqualizerSmall",
  __name: "IconEqualizerSmall",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const r = o;
    return (c, e) => (a(), n(l(u), m(r, { "view-box": "0 0 24 24" }), {
      default: p(() => [...e[0] || (e[0] = [
        i("path", {
          "fill-rule": "evenodd",
          d: "M10.647 8.25A2.751 2.751 0 0 0 5.25 9a2.75 2.75 0 0 0 5.397.75H18a.75.75 0 0 0 0-1.5h-7.353M9.25 9a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0m4.104 6.75a2.751 2.751 0 1 0 0-1.5H6a.75.75 0 0 0 0 1.5h7.354m2.646-2a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
